import { AxiosError } from 'axios';
import { subHours } from 'date-fns';
import { ThunkDispatch } from 'redux-thunk';

import { getCallLog as APIGetCallLog } from 'services/api/api.contact';

import { ContactInitiationMethod } from 'store/contactSearch/contactSearch.types';
import RootState from 'store/state';
import { getSettingsAppConfigForChannel, getSettingsChannelFromPath } from 'store/settings/settings.utils';
import { logout } from 'store/user/user.actions';

import { secondsFrom } from 'utils';

import { ICallLog } from './callLog.state';
import ContactState from '../contact/contact.state';
import CallLogTypes from './callLog.types';

export type CallLogAction =
    | { type: typeof CallLogTypes.ADD_TO_CALL_LOG; payload: ICallLog }
    | { type: typeof CallLogTypes.GET_CALL_LOG; payload: ICallLog[] }
    | { type: typeof CallLogTypes.FLUSH_OLD_CALL_LOGS };


export function addToCallLog(contact: ContactState): CallLogAction {
    const agentInteractionDuration = contact.agentInteractionDuration || (contact.connectedToAgentTimestamp ? secondsFrom(contact.connectedToAgentTimestamp) : 0);
    const disconnectTimestamp = contact.disconnectTimestamp || Date.now();
    return {
        type: CallLogTypes.ADD_TO_CALL_LOG,
        payload: {
            ...contact,
            source: 'LOCAL',
            agentInteractionDuration,
            disconnectTimestamp
        }
    };
}

const DEFAULT_HISTORY_HOURS = 72;

export function getCallLog() {
    return async (
        dispatch: ThunkDispatch<RootState, undefined, CallLogAction>,
        getState: () => RootState
    ) => {
        const { app: { ID, instance }, auth, settings: { settings } } = getState();
        const { token } = auth
        const settingsChannel = getSettingsChannelFromPath(window.location.pathname)
        const callHistoryHoursValue =
            getSettingsAppConfigForChannel(settings?.appConfigurations, settingsChannel)
                ?.callHistoryHours ?? DEFAULT_HISTORY_HOURS
        const dateFrom = subHours(
            new Date(),
            callHistoryHoursValue
        ).toISOString()
        try {
            const response = await APIGetCallLog(ID, instance!.ID, token!, dateFrom);
            const payload =
                    response
                    .filter(c => [
                        ContactInitiationMethod.CALLBACK,
                        ContactInitiationMethod.INBOUND,
                        ContactInitiationMethod.OUTBOUND,
                        ContactInitiationMethod.API
                    ].includes(c.initiationMethod as ContactInitiationMethod))
                    .map(c => ({
                        ...c,
                        source: 'API',
                        //DPA:getDPAState(c.attributes)
                    }) as ICallLog)
                    .sort((c1, c2) => (c1.connectedToAgentTimestamp ?? c1.initiationTimestamp) < (c2.connectedToAgentTimestamp ?? c2.initiationTimestamp) ? 1 : -1)
            dispatch({
                type: CallLogTypes.GET_CALL_LOG,
                payload
            })
        } catch (error) {
            console.log(error);
            const e = error as AxiosError;
            if (e.response?.status === 403) return dispatch(logout())
            dispatch({ type: CallLogTypes.FLUSH_OLD_CALL_LOGS });
        }
    }

}
